export default __webpack_public_path__ + "static/media/Prime-Regular.15b38dac.woff2";